import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import ProfileAssetHeading from './ProfileAssetHeading';

const About: React.FC<AssetBlockProps> = ({ asset }) => {
  const { description } = asset;
  return (
    <div>
      <ProfileAssetHeading heading="About this asset" />
      <TextBlock style={{ marginTop: 24 }} size={16}>
        {description}
      </TextBlock>
    </div>
  );
};

export default About;
